// client/src/pages/VerifyAccount.js

import React, { useEffect, useState } from 'react';
import axios from 'axios';

export default function VerifyAccount() {
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    if (!token) {
      setError('No token provided.');
      return;
    }

    // Call server to verify
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/auth/verify?token=${token}`)
      .then((res) => {
        setMessage(res.data.message || 'Account verified. You can now log in.');
      })
      .catch((err) => {
        setError(err.response?.data?.message || 'Verification failed.');
      });
  }, []);

  return (
    <div className="max-w-md mx-auto p-4 mt-16 text-center">
      {error && <p className="text-red-500">{error}</p>}
      {message && <p className="text-green-600">{message}</p>}
    </div>
  );
}
